import { Col, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import './style.scss';

const PageNavigation = ({ handleSelectPage, pageCount, currentPage }) => {


  return (
    <Row id='pageNavigator'>
      <Col className='align-items-center d-flex justify-content-lg-center pageNavigator'>
        <div className={`chevPageBtn ${currentPage <= 1 ? 'disabled' : ''}`} onClick={() => currentPage <= 1 ? undefined : handleSelectPage(currentPage - 1)}>
          <FontAwesomeIcon color={currentPage <= 1 ? '#8080803d' : '#7085C5'} icon={faChevronLeft} />
        </div>
        {Array.from({ length: Math.min(pageCount, 10) }, (pageNumber, i) => {
          if (pageCount >= 10 && currentPage >= pageCount - 5) {
            pageNumber = pageCount - 9 + i;
          } else if (currentPage <= 5 || pageCount < 10) {
            pageNumber = i + 1;
          } else {
            pageNumber = currentPage - 4 + i;
          }

          return (
            <div className={`pageBtn ${pageNumber == currentPage ? 'selected' : ''} `} key={`pageBtn_${i}`} onClick={() => handleSelectPage(pageNumber)}>{pageNumber}</div>
          );
        })}
        <div className={`chevPageBtn ${currentPage >= pageCount ? 'disabled' : ''}`} onClick={() => currentPage >= pageCount ? undefined : handleSelectPage(currentPage + 1)}>
          <FontAwesomeIcon color={currentPage >= pageCount ? '#8080803d' : '#7085C5'} icon={faChevronRight} />
        </div>
        <DropdownButton id='dropdown-page-selection' title={currentPage} variant='castleDropdown' className='mx-2' drop='up'>
          {Array.from({ length: Math.min(pageCount) }, (_, i) => (
            <Dropdown.Item key={`dropDown-Item${i}`} active={currentPage == i + 1} onClick={() => handleSelectPage(i + 1)}>{i + 1}</Dropdown.Item>
          ))}
        </DropdownButton>
      </Col>
    </Row>
  );
};

export default PageNavigation;